module.exports = __webpack_public_path__ + "static/img/operateDay.4c2f249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateDay.png
// module id = mnBF
// module chunks = 1